// removed by extract-text-webpack-plugin
module.exports = {"main":"_26WBsq81-CV7Wv5nSlQUZi"};


//////////////////
// WEBPACK FOOTER
// ./components/ForgotDone.module.css
// module id = 2354
// module chunks = 1